export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";